import client from './client';

export async function getNoticeList(params) {
  const res = await client.get('/admin/notice', { params });
  return res.data;
}

export async function getNotice(noticeId) {
  const res = await client.get(`/admin/notice/${noticeId}`);
  return res.data;
}

export async function createNotice(payload) {
  const res = await client.post('/admin/notice', payload);
  return res.data;
}

export async function updateNotice(noticeId, payload) {
  const res = await client.put(`/admin/notice/${noticeId}`, payload);
  return res.data;
}

export async function deleteNotice(noticeId) {
  const res = await client.delete(`/admin/notice/${noticeId}`);
  return res.data;
}

export async function getNoticeAttachments(noticeId) {
  const res = await client.get(`/admin/notice/${noticeId}/attach`);
  return res.data;
}

export async function uploadNoticeAttachments(noticeId, files, createdBy) {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  formData.append('createdBy', createdBy);
  // Content-Type 을 직접 지정하지 않는다 - FormData 전송 시 브라우저가
  // boundary 를 포함한 정확한 multipart/form-data 헤더를 자동으로 설정해야 한다.
  const res = await client.post(`/admin/notice/${noticeId}/attach`, formData);
  return res.data;
}

export async function deleteNoticeAttachment(attachId) {
  const res = await client.delete(`/admin/notice/attach/${attachId}`);
  return res.data;
}

/**
 * 첨부파일 다운로드. JWT 인증이 필요하므로 <a href> 로는 헤더를 실어보낼 수 없어
 * axios 로 blob 을 받아온 뒤 브라우저 다운로드를 프로그래밍적으로 트리거한다.
 */
export async function downloadNoticeAttachment(attachId, originalName) {
  const res = await client.get(`/admin/notice/attach/${attachId}/download`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = originalName || 'download';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
